// Textos de la página de inicio (Home.jsx) — traducción española de fr/home.js.
// Mismas claves, mismo orden. Los nombres de marca (Joyful Reveal, Mirum Games,
// Pack Essentiel, Pack Premium) quedan sin traducir.
export default {
  'home.seo.titre': 'Joyful Reveal - Juego de gender reveal: juegue para revelar el sexo del bebé | Mirum Games',
  'home.seo.description': 'Convierta su fiesta de gender reveal en un juego: 2 equipos, preguntas divertidas, 11 piezas de puzle por ganar y una pieza final que revela el sexo del bebé. Envío rápido a España, Bélgica y Francia.',

  'home.etat.chargement': 'Cargando...',

  'home.vitrine.badge': '🧩 Nuestra colección',
  'home.vitrine.description': '¡Un concepto único que convierte la revelación del sexo del bebé en un divertido juego de preguntas y respuestas! Reúna a sus seres queridos, formen equipos y vivan juntos ese momento mágico que quedará grabado en su memoria.',
  'home.vitrine.altProduit': 'Joyful Reveal Ositos - Puzle ecológico que revela el sexo del bebé - Mirum Games',

  'home.packs.titre': 'Elija su pack',
  'home.packs.economisez': 'Ahorre un {pct}%',
  'home.packs.selectionne': '✓ Seleccionado',
  'home.packs.selectionner': 'Seleccionar',
  'home.packs.voirFiche': '📋 Ver la ficha completa',

  'home.recap.packChoisi': 'Pack elegido:',
  'home.recap.prixTotal': 'Precio total:',

  'home.genre.cestPour': 'Es para...',
  'home.genre.contenuPack': 'Contenido del pack',
  'home.genre.packMixte': 'Pack mixto: ¡niña + niño incluidos!',
  'home.genre.versionGarcon': 'Versión Niño preseleccionada',
  'home.genre.versionFille': 'Versión Niña preseleccionada',

  // Etiquetas de variante: sirven para los botones Niño/Niña Y para el nombre
  // compuesto del producto que entra en el carrito (una clave por variante).
  'home.variante.garcon': 'Niño',
  'home.variante.fille': 'Niña',
  'home.variante.mixte': 'Niña + Niño',

  'home.cta.ajouterPanier': '🛒 Añadir al carrito',
  'home.cta.voirFichePack': '📋 Ver la ficha completa del {pack}',
  'home.cta.magique': '✨ Cree un momento mágico con su familia',

  'home.badges.cleEnMain': 'Todo listo',
  'home.badges.pretAOffrir': 'Listo para regalar',
  'home.badges.livraisonRapide': 'Envío rápido',

  'home.concept.badge': '✨ Nuestro concepto único',
  // Frases cortadas alrededor de los <strong>: antes / palabra fuerte / después.
  'home.concept.question': '¿Una niña? ¿Un niño?',
  'home.concept.questionSuite': '¿Todos a su alrededor se mueren de ganas de saber de qué equipo será su futuro bebé?',
  'home.concept.annonce': '¡Anuncie la noticia de una forma divertida y original con nuestro juego!',
  'home.concept.puzzleAvant': 'Este puzle es',
  'home.concept.puzzleMot': 'único',
  'home.concept.puzzleApres': 'porque se construye participando en un divertido juego de preguntas y respuestas, para acabar revelando el pequeño secreto del bebé.',
  'home.concept.experienceAvant': 'Mucho más que un puzle, es una',
  'home.concept.experienceMot': 'experiencia de alegría compartida',
  'home.concept.experienceApres': 'entre amigos y en familia. ¡Reúna a sus seres queridos, formen equipos y disfruten de este momento único en su vida!',
  'home.concept.cadeauAvant': 'Tanto si son una pareja de futuros padres como si organizan una',
  'home.concept.cadeauMot': 'Gender Reveal Party',
  'home.concept.cadeauApres': 'para alguien muy querido, nuestro juego hará que ese día sea aún más inolvidable.',

  'home.instagram.badge': '📸 Momentos mágicos',
  'home.instagram.titre': '¡Descubra nuestro puzle en acción! 🎉',
  'home.instagram.sousTitre': 'Vea cómo viven nuestros clientes su revelación mágica con Joyful Reveal',
  'home.instagram.altReel': 'Dos futuros padres rodeados de piezas de puzle, ilustración Joyful Reveal',
  'home.instagram.voirSur': 'Ver en Instagram',
  'home.instagram.momentTitre': 'Un momento inolvidable',
  'home.instagram.momentTexte': 'Nuestros puzles convierten la revelación en una experiencia interactiva y festiva. ¡Monten las piezas en familia y descubran juntos el gran secreto!',
  'home.instagram.jeuInteractif': 'Juego interactivo',
  'home.instagram.enFamille': 'En familia',
  'home.instagram.suivezNous': 'Síganos en Instagram',
};
